import { ConcreteEncodable } from "./ConcreteEncodable";

import { FillNowLockResponseImplEncoder } from "../../encoder/FillNowLockResponseImplEncoder";

import * as CubiqTS from "../../index";
import { FillNowLockResponse } from "../FillNowLockResponse";

export class FillNowLockResponseImpl extends ConcreteEncodable implements FillNowLockResponse {
  public static enType: string = "com.bcdfx.model.FillNowLockResponseImpl";

  /*FID=1*/
  public orderId: string;
  /*FID=2*/
  public orderAmt: CubiqTS.BigNumber | null = null;
  /*FID=3*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FillNowLockResponseImplEncoder.Instance;
    this.setEncodableType(FillNowLockResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "FillNowLockResponseImpl[" +
      "orderId=" +
      this.orderId +
      "orderAmt=" +
      this.orderAmt +
      "errors=" +
      this.errors +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
